import { Component } from "@angular/core";
import { NavButton } from "../navigation/next-button.component";
import { AppFlowService } from "../../services/app-flow/app-flow.service";

@Component({
  selector: "app-add-item",
  templateUrl: "./add-item.component.html",
})
export class AddItemComponent {
  nextButton: NavButton = {
    buttonText: "Continue",
    cssClass: "next-btn",
    isDisable: true,
  };
  screenNav: NavButton = {
    buttonText: "Select return items",
    cssClass: "my-class",
    routeUrl: "/d/main",
  };

  constructor(private appFlowService: AppFlowService) {
    const route = this.appFlowService.findRouteFromSequence("additems");
    this.nextButton.routeUrl = `/d/${route.next}`;
    this.screenNav.routeUrl = `/d/${route.back}`;
    this.nextButton.isDisable = true;
  }
}
